import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TntToolModule } from './create-tool/tnt-tool.module';

// Services
import {
  TntService,
  ApplicationService,
  ApplicationSystemService,
  TntSystemService,
  TntSystemCenterService,
  TntToolService,
  TntToolTypeService,
  TntToolTypeApplicationService,
  TntToolReferenceFileService,
  TntToolUsageService,
  TntToolVersionService,
  TntCenterService,
  TntToolOwnerService,
  TntArchivedToolService,
} from './tnt.service';

// Components
import { TntComponent } from './tnt.component';
import { TntAdministrationComponent } from './administration/administration.component';
import { TntMaintenanceComponent } from './administration/maintenance/maintenance.component';
import { TntSecurityComponent } from './administration/security/security.component';
import { ToolIdentificationMatrixComponent } from './administration/tool-identification-matrix/tool-identification-matrix.component';

import { ZoneSubZoneTitleComponent } from './administration/zone-sub-zone-title/zone-sub-zone-title.component';
import { TransferToolsComponent } from './administration/transfer-tools/transfer-tools.component';
import { ToolOwnershipComponent } from './administration/tool-ownership/tool-ownership.component';
import { ArchiveToolsComponent } from './administration/archive-tools/archive-tools.component';
import { ToolTeamcenterLinkComponent } from './administration/tool-teamcenter-link/tool-teamcenter-link.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { S3Service } from '../../shared/s3.service';
@NgModule({
  imports: [
    HttpClientModule,
    SharedModule,
    TntToolModule,
    MatCardModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatIconModule
  ],
  declarations: [
    TntComponent,
    TntAdministrationComponent,
    TntMaintenanceComponent,
    TntSecurityComponent,
    ToolIdentificationMatrixComponent,
    ZoneSubZoneTitleComponent,
    TransferToolsComponent,
    ToolOwnershipComponent,
    ArchiveToolsComponent,
    ToolTeamcenterLinkComponent,
  ],
  providers: [
    TntService,
    ApplicationService,
    ApplicationSystemService,
    TntSystemService,
    TntToolVersionService,
    TntToolService,
    TntToolTypeService,
    TntToolTypeApplicationService,
    TntToolReferenceFileService,
    TntToolUsageService,
    TntSystemCenterService,
    TntCenterService,
    TntToolOwnerService,
    TntArchivedToolService,
    S3Service
  ]
})
export class TntModule { }
